import { useState } from 'react';
import clsx from 'clsx';

const EMOJI_GROUPS = [
  ['🍔', '🍕', '🍟', '🥤', '🥨', '🍿', '🍰', '🍩', '🍪', '🧁', '🍦', '🍫'],
  ['🧸', '🎈', '🎁', '🎲', '🪀', '🚗', '🚂', '🛴', '⚽', '🏀', '🪅', '🎮'],
  ['📦', '🎫', '🎀', '🪙', '🔧', '✨', '⭐', '💎', '🌈', '🎨', '🧩', '🪁']
];

export function EmojiPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((s) => !s)}
        className="aspect-square w-[80px] rounded-[12px] border-2 border-dashed border-line-2 grid place-items-center text-[36px] bg-paper-2 hover:bg-paper"
      >
        {value || '🎁'}
      </button>
      {open ? (
        <div
          className="absolute z-30 mt-2 p-2 bg-white border border-line rounded-[12px] shadow-card w-[260px]"
          onMouseLeave={() => setOpen(false)}
        >
          {EMOJI_GROUPS.map((group, gi) => (
            <div key={gi} className="grid grid-cols-6 gap-1 mb-1">
              {group.map((e) => (
                <button
                  key={e}
                  type="button"
                  onClick={() => { onChange(e); setOpen(false); }}
                  className={clsx(
                    'h-9 w-9 rounded-[8px] grid place-items-center text-[20px] hover:bg-paper-2',
                    value === e && 'bg-orange-soft'
                  )}
                >
                  {e}
                </button>
              ))}
            </div>
          ))}
          <input
            className="input text-[13px] mt-1"
            placeholder="أو أدخل إيموجي يدوياً"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      ) : null}
    </div>
  );
}
